module.exports = function getResource(label, vars = []) {
    let resources = {
        userLabelText: `You must be ${vars[0]} to access this product.`,
        signIn: 'Sign in',
        or: ' or ',
        signUp: 'Sign up',
        learnMore: 'Learn more',
        downloadOpenApp: 'Download or open the Sephora app to purchase.'
    };
    return resources[label];
};
